// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1IMhr","errors":"Errors_errors__3hGGu"};